$(document).ready(function(){
	// Add CSS for size label underline
	var style = document.createElement('style');
	style.innerHTML = `
	  .size-label::after {
	    content: '';
	    position: absolute;
	    bottom: 0;
	    left: 0;
	    width: 0;
	    height: 2px;
	    background-color: #000;
	    transition: width 0.3s ease;
	  }
	  
	  .size-label.selected::after {
	    width: 100%;
	  }
	  
	  .size-label {
	    position: relative;
	    display: inline-block;
	  }
	`;
	document.head.appendChild(style);
	
	$(".search__overlay,.search__input-close").on("click",function(e){
            e.preventDefault();
      
            $(".header__icon-wrapper").removeClass('is-active');
    });
    $(".quick-search__trigger").on("click",function(e){
            e.preventDefault();
            
            $(this).parents(".header__icon-wrapper").addClass('is-active');
    });
    /* Product Slider */
    if($(window).width() < 608){
      initProductMediaSlider(".product_custom")
    }
  	$(window).on( 'resize', function() {
      if($(window).width() < 608){
        initProductMediaSlider(".product_custom")
      }
   });
  let ps = '[name^="options"]';
  $(document).on("change",ps,function(){
    let sel = document.querySelector('[name="id"]');
    let featured_media = sel.options[sel.selectedIndex].dataset.img;
    if(featured_media){
       let el = $('[data-product-single-media-wrapper][data-id="'+featured_media+'"]');
       $('[data-product-single-media-slider]').flickity('select', el.index());
    }
  });
  $(document).on( 'click', ".product-single__thumbnail", function(e) {
  		e.preventDefault();

  		var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  		
  		if (windowWidth < 768) {
  			var id = $(this).parent().data( 'id' ),
  				$selectedImage = $( '[data-product-single-media-wrapper]' + '[data-id="' + id + '"]'),
  				headerHeight = 59,
  				additionalSpace = 40;

  			if ( $selectedImage.length ) {
  				var mediaId = $selectedImage.data( 'media-id' );
  				switchMedia( '.product_custom', mediaId )
  			}
  		}
  });
  
  // Custom size selection functionality
  $(document).on('click', '.size-label', function(e) {
    e.preventDefault();
    
    // Check if the size is sold out
    if ($(this).hasClass('sold-out')) {
      // Update the add to cart button to show "Sold Out"
      $('[data-add-button]').each(function() {
        $(this).prop('disabled', true);
        $(this).find('[data-add-button-text]').text($(this).data('lang-sold-out'));
      });
      return;
    }
    
    // Remove selected class from all labels
    $('.size-label').removeClass('selected');
    
    // Add selected class to clicked label
    $(this).addClass('selected');
    
    // Check the corresponding radio input
    var inputId = $(this).attr('for');
    var $radioInput = $('#' + inputId);
    $radioInput.prop('checked', true).trigger('change');
    
    // Update price based on selected variant
    var variantId = $radioInput.data('variant-id');
    var price = $radioInput.data('price');
    var comparePrice = $radioInput.data('compare-price');
    
    if (variantId) {
      // Update the variant selector
      $('[data-variant-select]').val(variantId).trigger('change');
      
      // Update price display directly from the radio input data
      if (price !== undefined) {
        $('[data-product-price]').text(formatMoney(price));
        
        // Update compare price if available
        if (comparePrice && comparePrice > price) {
          $('[data-compare-price]').text(formatMoney(comparePrice)).show();
          $('[data-product-price]').addClass('sale');
        } else {
          $('[data-compare-price]').hide();
          $('[data-product-price]').removeClass('sale');
        }
      }
    }
    
    // Reset the add to cart button
    $('[data-add-button]').each(function() {
      $(this).prop('disabled', false);
      $(this).find('[data-add-button-text]').text($(this).data('lang-available'));
    });
  });
  
  // Set the first available size as selected by default
  // Find size labels within each option group and select the first available one
  $('.size-selection').each(function() {
    var firstAvailable = $(this).find('.size-label:not(.sold-out)').first();
    if (firstAvailable.length > 0 && firstAvailable.siblings('.size-label.selected').length === 0) {
      // Only select if no size is already selected
      firstAvailable.addClass('selected');
      var inputId = firstAvailable.attr('for');
      $('#' + inputId).prop('checked', true);
    }
  });
  
});

function initProductMediaSlider( container ){
    	var self = this,
			$productImgSlider = $('[data-product-single-media-slider]', container ),
			$productImgSliderNav = $('[data-product-single-media-thumbs]', container ),
			activeArrows = $productImgSlider.data( 'arrows' ),
			activeDots = $productImgSlider.data( 'dots' ),
			isDraggable = !( $('.product-single__media--video', $productImgSlider ).length || $('.product-single__media--model', $productImgSlider ).length),
			activeSlide = $('.is-selected', $productImgSlider ).index(),
			hasSlides = $( '[data-product-single-media-wrapper]', $productImgSlider ).length > 1,
			lastWindowWidth = window.innerWidth || document.documentElement.clientWidth;
      var navarrow = 'M0.0776563715,49.6974826 L0.0776563715,50.3266624 C0.0882978908,50.4524827 0.146435015,50.5626537 0.234305795,50.6407437 C0.234697028,50.7982538 0.39181593,50.7982538 0.39181593,50.9556075 C0.39181593,51.1129611 0.548934833,51.1127264 0.548934833,51.27008 C0.636101395,51.27008 0.706053735,51.3405018 0.706053735,51.4271989 L36.3981789,88.377449 C36.9898787,88.9427015 37.7935482,89.2908983 38.6778897,89.2908983 C39.5622313,89.2908983 40.3661354,88.9429363 40.9590089,88.3761189 C41.5534473,87.8297238 41.9253528,87.0464767 41.9253528,86.1759065 C41.9253528,85.3053363 41.5534473,84.5227934 40.9597131,83.9766331 L10.297036,52.0652206 L96.9330092,52.8421298 C98.6696895,52.8421298 100.077578,51.4342411 100.077578,49.6975608 C100.077578,47.9608805 98.6696895,46.5529919 96.9330092,46.5529919 L10.297036,46.5529919 L40.9578352,15.4206794 C41.4680804,14.8636428 41.7811445,14.1180323 41.7811445,13.299496 C41.7811445,12.4018526 41.4053267,11.5926276 40.8022812,11.0197852 C40.2533823,10.422843 39.4701352,10.0509375 38.599565,10.0509375 C37.7289948,10.0509375 36.9464519,10.422843 36.4002916,11.0165771 L36.3981007,11.018768 L0.863172638,47.1829542 C0.863172638,47.3400731 0.863172638,47.3400731 0.706053735,47.4974267 C0.618887173,47.4974267 0.548934833,47.5678485 0.548934833,47.6545456 C0.548934833,47.8116645 0.39181593,47.8116645 0.39181593,47.9690181 L0.234697028,47.9690181 L0.234697028,48.2834907 C0.146356768,48.3619719 0.0882196443,48.4723777 0.077578125,48.5964766 L0.077578125,49.6984215 L0.0776563715,49.6974826 Z';
  		var prevarrow = '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M0.0776563715,49.6974826 L0.0776563715,50.3266624 C0.0882978908,50.4524827 0.146435015,50.5626537 0.234305795,50.6407437 C0.234697028,50.7982538 0.39181593,50.7982538 0.39181593,50.9556075 C0.39181593,51.1129611 0.548934833,51.1127264 0.548934833,51.27008 C0.636101395,51.27008 0.706053735,51.3405018 0.706053735,51.4271989 L36.3981789,88.377449 C36.9898787,88.9427015 37.7935482,89.2908983 38.6778897,89.2908983 C39.5622313,89.2908983 40.3661354,88.9429363 40.9590089,88.3761189 C41.5534473,87.8297238 41.9253528,87.0464767 41.9253528,86.1759065 C41.9253528,85.3053363 41.5534473,84.5227934 40.9597131,83.9766331 L10.297036,52.0652206 L96.9330092,52.8421298 C98.6696895,52.8421298 100.077578,51.4342411 100.077578,49.6975608 C100.077578,47.9608805 98.6696895,46.5529919 96.9330092,46.5529919 L10.297036,46.5529919 L40.9578352,15.4206794 C41.4680804,14.8636428 41.7811445,14.1180323 41.7811445,13.299496 C41.7811445,12.4018526 41.4053267,11.5926276 40.8022812,11.0197852 C40.2533823,10.422843 39.4701352,10.0509375 38.599565,10.0509375 C37.7289948,10.0509375 36.9464519,10.422843 36.4002916,11.0165771 L36.3981007,11.018768 L0.863172638,47.1829542 C0.863172638,47.3400731 0.863172638,47.3400731 0.706053735,47.4974267 C0.618887173,47.4974267 0.548934833,47.5678485 0.548934833,47.6545456 C0.548934833,47.8116645 0.39181593,47.8116645 0.39181593,47.9690181 L0.234697028,47.9690181 L0.234697028,48.2834907 C0.146356768,48.3619719 0.0882196443,48.4723777 0.077578125,48.5964766 L0.077578125,49.6984215 L0.0776563715,49.6974826 Z" class="arrow"></path></svg>';    
  activeSlide = activeSlide == -1 ? 0 : activeSlide;
      
      if ( hasSlides && !$productImgSlider.hasClass('slick-initialized')){
        
      	$productImgSlider
				.on( 'ready.flickity', function() {
					$productImgSlider.attr( 'tabindex', '-1' );
					$( '[data-product-single-media-wrapper]', $productImgSlider ).attr( 'tabindex', '-1' );
				})
				.on( 'change.flickity', function( event, index ) {
					var $currentSlide = $( '[data-product-single-media-wrapper]', $productImgSlider ).eq( index ),
						$currentSlideImage = $( '.product-single__media--image', $currentSlide );

					if ( !$currentSlideImage.hasClass( 'lazyloaded' ) ) {
						$currentSlideImage.addClass( 'lazyload' );
					}

					
				});
              	$productImgSlider.flickity({
                      cellSelector: "[data-product-single-media-wrapper]",
                      prevNextButtons: activeArrows,
                      arrowShape: navarrow,
                      pageDots: activeDots,
                      initialIndex: activeSlide,
                      draggable: isDraggable,
                      adaptiveHeight: true,
                      contain: true,
                      wrapAround: true
                  });
//         $productImgSlider.slick({
//           infinite: false,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           vertical:true,
//           dots: true,
//           arrows: true,
//           adaptiveHeight: true,
//           speed:2000,
//           draggable: true,
//           verticalSwiping: true,
//           centerMode: false,
//           focusOnSelect: true,
//           nextArrow:'<button type="button" class="slick-next">'+navarrow+'</button>',
//           prevArrow: '<button type="button" class="slick-prev">'+prevarrow+'</button>'
//         });
        initSliderNav();
        function initSliderNav() {
				var isInitialized = $productImgSliderNav.data( 'flickity' ),
					sliderNavArrows = checkThumbnailsOverflow( $productImgSliderNav );

				if ( isInitialized != undefined ) {
					$productImgSliderNav.flickity( 'destroy' );
				}

				$productImgSliderNav.flickity({
					cellSelector: '[data-thumbnail]',
					asNavFor: $productImgSlider[0],
					initialIndex: activeSlide,
					pageDots: false,
					prevNextButtons: sliderNavArrows,
					arrowShape: navarrow,
					contain: true,
					wrapAround: sliderNavArrows
				});
			}
			
      }
    }

 function checkThumbnailsOverflow( $thumbs ) {
				var thumbWidth = $thumbs.find( '.product-single__media-thumb' ).outerWidth(),
					slidesCount = $thumbs.find( '.product-single__media-thumb' ).length,
					slidesWidth = parseInt( thumbWidth * slidesCount ),
					slidesContainerWidth = $thumbs.width();

				return (slidesContainerWidth < slidesWidth);
			}
function switchMedia( container, mediaId ) {
		var $currentMedia = $( '[data-product-single-media-wrapper]' + ':not(.media--hidden)', container ),
			$newMedia = $( '[data-product-single-media-wrapper]' + '[data-media-id="' + mediaId + '"]', container ),
			$otherMedia = $( '[data-product-single-media-wrapper]' + ':not([data-media-id="' + mediaId + '"])', container ),
			isFocusEnabled = !$('body').hasClass( 'no-outline' );

		if ( isFocusEnabled ) $newMedia.focus();

		$currentMedia.trigger( 'mediaHidden' );
		$newMedia.removeClass( 'media--hidden' ).trigger( 'mediaVisible' );
		$otherMedia.addClass( 'media--hidden' );
	}
	
		
		// Function to format money values
		function formatMoney(cents) {
		  // Convert cents to dollars and format as currency
		  var dollars = cents / 100;
		  // Use Shopify's money format if available, otherwise default to USD
		  if (typeof Shopify !== 'undefined' && Shopify.money_format) {
		    return Shopify.formatMoney(cents, Shopify.money_format);
		  } else {
		    return '$' + dollars.toFixed(2);
		  }
		}